import { useState, useEffect } from 'react';

export const usePasswordAccess = () => {
  const [hasAccess, setHasAccess] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if user already has access
    const accessGranted = localStorage.getItem('mindset_access_granted');
    setHasAccess(accessGranted === 'true');
    setLoading(false);
  }, []);

  const grantAccess = () => {
    setHasAccess(true);
    localStorage.setItem('mindset_access_granted', 'true');
  };

  const revokeAccess = () => {
    setHasAccess(false);
    localStorage.removeItem('mindset_access_granted');
  };

  return {
    hasAccess,
    loading,
    grantAccess,
    revokeAccess
  };
};